/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CriterionInputOutput } from './criterionInputOutput';
import type { SearchFiltersSchema } from './searchFiltersSchema';

/**
 * API shape of a search definition: filters + criteria + rerank_query.
 *
 * Mirrors ``app.services.search.definition.SearchDefinition`` field-for-field
 * (same constraints). Kept as a separate class so the schemas layer never
 * imports from the services layer.
 */
export interface SearchDefinitionSchemaOutput {
  filters?: SearchFiltersSchema;
  /** @maxItems 20 */
  criteria?: CriterionInputOutput[];
  rerank_query?: string | null;
  pool_ids?: string[] | null;
}
